import * as React from 'react';
import * as _ from 'lodash';
import { CoughReOpenComments, CoughReOpenCommentGroup } from '../../../../misc/api/apiTypes';
import LoadingWithMessage from '../../../../misc/components/LoadingWithMessage';
import Select from 'react-select';


export interface AuditModalReOpenCommentsProps {
    fixedComments?: CoughReOpenComments;
    onFixedCommentToggle?: (groupIndex: number, selectedComment: string) => void;
    fetchingComments: boolean;
}

/**
 * Component to render any fixed comments for selection.
 * */
export class AuditModalReOpenComments extends React.Component<AuditModalReOpenCommentsProps> {
    constructor(props: AuditModalReOpenCommentsProps) {
        super(props);

        let groupOrders = {};
        props.fixedComments.ReOpenCommentGroups.forEach((item) => {
            groupOrders[item.Order] = false;
        });

        this.state = {
            showErrors: false,
            groupOrders: groupOrders
        };
    }

    validateState(hasError: boolean) {
        this.setState({showErrors: true});
    }

    /**
     * Handling the change of options when a user selects something. 
     * @param selectedOption
     */
    setFixedComment(groupOrder: number, selectedOption) {
        this.props.onFixedCommentToggle && this.props.onFixedCommentToggle(groupOrder, selectedOption && selectedOption.value);
    }


    getAvailableOptions(reopenCommentGroup: CoughReOpenCommentGroup) {
        return _.map(reopenCommentGroup.Comments, fcGrComment => { return { value: fcGrComment, label: fcGrComment } });
    }

    hasFixedComments() {
        return this.props.fixedComments && this.props.fixedComments.ReOpenCommentGroups && this.props.fixedComments.ReOpenCommentGroups.length > 0;
    }

    renderComments() {
        return this.hasFixedComments() || this.props.fetchingComments ? (<div className="form-group"><label>Select A Single Option From Each Category</label>
            {this.hasFixedComments() ? this.renderSelects() : null}
            {this.props.fetchingComments ? <LoadingWithMessage message="Checking For Required Fixed Comments..." /> : null}

        </div>) : null;
    }

    renderSelects() {
        return _.map(this.props.fixedComments.ReOpenCommentGroups, reFC => {
            return this.renderSelect(reFC);
        });
    }

    renderSelect(reopenCommentGroup: CoughReOpenCommentGroup) {
        return <div key={reopenCommentGroup.GroupName} className="form-group">
            <label htmlFor={reopenCommentGroup.GroupName}>{reopenCommentGroup.GroupName}</label>
            <Select
                styles={{
                    control: (base) => ({
                        ...base,
                        borderColor: this.state['showErrors'] && (this.state[reopenCommentGroup.Order] ?? true)? 'red': ''
                    })
                }}
                name={reopenCommentGroup.GroupName}
                isDisabled={!!this.props.fetchingComments}
                classNamePrefix={reopenCommentGroup.GroupName}
                options={this.getAvailableOptions(reopenCommentGroup)}
                getOptionValue={o => o.value}
                getOptionLabel={o => o.label}
                value={this.getAvailableOptions(reopenCommentGroup).find(o => o.value === reopenCommentGroup.SelectedOption)}
                isMulti={false}
                onChange={(selectedComment) => {
                    this.setFixedComment(reopenCommentGroup.Order, selectedComment);
                    this.setState({ [reopenCommentGroup.Order]: false });
            }} />
        </div>;
    }

    render() {
        return this.renderComments();
    }
}
